import { createReducer, on } from '@ngrx/store';
import * as propertyActions from 'src/app/STORE/actions/propertypane.actions';

export interface PropertyState {
  commonProperties: any;
}

export const initialState: PropertyState = {
  commonProperties: {}
};

export const propertiesReducer = createReducer(
  initialState,
  on(propertyActions.getPropertiesData, (state, { propPaneApiConstants }) => ({
    ...state,
    ...propPaneApiConstants
  })),
  on(propertyActions.setPropertiesData, (state, { propertiesData }) => {
    const props = propertiesData ? propertiesData : [];
    return {
      ...state,
      ...{ propertiesData: props }
    };
  }),
  on(propertyActions.setAllPropertiesData, (state, { allProperties }) => {
    //console.log(allProperties);
    return {
      ...state,
      ...{
        allProperties: allProperties
      }
    };
  }),
  on(propertyActions.setPropertiesValues, (state, { propertiesValues, currentScreenId }) => {
    //console.log(propertiesValues);
    //console.log(state);
    return {
      ...state,
      ...{ propertiesValues },
      ...{ currentScreenId }
    };
  }),
  on(propertyActions.setScreenValues, (state, { screenValues }) => {
    return {
      ...state,
      ...{ screenValues }
    };
  }),
  on(propertyActions.setPropertiesType, (state, { propertiesType }) => {
    return {
      ...state,
      propertiesType
    };
  }),
  on(propertyActions.getPropertiesType, (state, { propertiesType }) => {
    return {
      ...state,
      propertiesType
    };
  }),
  on(propertyActions.deletePropertiesValues, (state, { propertyId }) => {
    return {
      ...state
    };
  }),

  on(propertyActions.setPickupProperties, (state, { picklist }) => {
    return {
      ...state,
      picklist
    };
  }),
  on(propertyActions.setLookupFields, (state, { lookupFields }) => {
    return {
      ...state,
      ...{ lookupFields }
    };
  }),
  on(propertyActions.setMandatryFil, (state, { mandatoryFilters }) => {
    return {
      ...state,
      ...{ mandatoryFilters }
    };
  }),
  on(propertyActions.setParentNodeType, (state, { parentNodeType }) => {
    return {
      ...state,
      ...{ parentNodeType }
    };
  }),
  on(propertyActions.settableFields, (state, { tabMapFlds }) => {
    return {
      ...state,
      ...{ tabMapFlds }
    };
  }),
  on(propertyActions.setMFTblFields, (state, { mfTblFlds }) => {
    return {
      ...state,
      ...{ mfTblFlds }
    };
  }),
  on(propertyActions.setLkfuncPKFields, (state, { funcPKflds }) => {
    return {
      ...state,
      ...{ funcPKflds }
    };
  }),
  on(propertyActions.setSelectedLKTbl, (state, { selLkTbl }) => {
    return {
      ...state,
      ...{ selLkTbl }
    };
  }),
  on(propertyActions.triggerLoading, (state, { triggerPropLoading }) => {
    return {
      ...state,
      ...{ triggerPropLoading }
    };
  }),
  on(propertyActions.setTableNames, (state, { tableNames }) => {
    return {
      ...state,
      tableNames
    };
  }),
  on(propertyActions.clearLookUp, (state, { clear }) => ({
    ...state,
    ...{ clear }
  })),
  on(propertyActions.setCurrentNodeData, (state, { curNodeData }) => {
    return {
      ...state,
      ...{ curNodeData }
    };
  }),
  on(propertyActions.setSearchableFields, (state, { searchFields }) => ({
    ...state,
    ...{ searchFields }
  }))
);
